import { render, staticRenderFns } from "./edit-prize.vue?vue&type=template&id=7f6b735a&"
import script from "./edit-prize.vue?vue&type=script&lang=js&"
export * from "./edit-prize.vue?vue&type=script&lang=js&"
import style0 from "./edit-prize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports